import { render } from "./SimpleDashboard.vue?vue&type=template&id=3e32a022&scoped=true"
import script from "./SimpleDashboard.vue?vue&type=script&lang=js"
export * from "./SimpleDashboard.vue?vue&type=script&lang=js"

import "./SimpleDashboard.vue?vue&type=style&index=0&id=3e32a022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e32a022"]])

export default __exports__